import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-brand-bgAlt" data-id="element-72">
      <div className="max-w-2xl mx-auto" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border border-green-300 rounded-3xl p-10 md:p-14 text-center flex flex-col items-center shadow-md" data-id="element-74">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 text-green-600 rounded-full mb-8 border border-green-200" data-id="element-75">
            <ShieldCheckIcon className="w-8 h-8" data-id="element-76" />
          </div>

          <h2 className="text-2xl md:text-3xl font-poppins font-black text-brand-text mb-6" data-id="element-77">
            🛡️ GARANTÍA 7 DÍAS
          </h2>

          <div className="space-y-3 text-lg md:text-xl font-medium text-gray-700" data-id="element-78">
            <p data-id="element-79">Lo probás.</p>
            <p data-id="element-80">
              Si no te sirve:{' '}
              <span className="font-bold text-brand-accent" data-id="element-81">
                💸 Te devolvemos el dinero.
              </span>
            </p>
            <p className="text-gray-500 italic mt-6 text-base" data-id="element-82">
              Sin preguntas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}